import {Parser} from "./AbstractParser";

export class ErrorParser extends Parser {
    parse() {
        return JSON.parse(this.input.message);
    };
}


// WEBPACK FOOTER //
// ./src/parser/ErrorParser.js